import React, { useContext, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { SliderPicker } from 'react-color';
import { CropTopContext } from "../../../context/croptopContext";
import FabricComponent from "../../Blouse/fabric";

const ColorCropTopComponent=()=>{
    const {updateCropColor,selectedCropItem}=useContext(CropTopContext);
    const [activeItem,setActiveItem]=useState("Color");
    const [color, setColor] = useState('#FFFFFF');

    const handleActive=(value)=>{
        setActiveItem(value)
    }

    const handleChange = (selectedColor) => {
        setColor(selectedColor.hex);
    };

    const getColorUpdate=(value)=>{
      updateCropColor(value);
      }

    return(
        <>
        <Col>
          <Button variant={activeItem === 'Color' ? "dark mx-1":"outline-dark mx-1"} size="sm" 
          onClick={()=>handleActive("Color")} disabled={!selectedCropItem}>Color</Button>
          <Button variant={activeItem === 'Fabric' ? "dark mx-1":"outline-dark mx-1"} size="sm"
          onClick={()=>handleActive("Fabric")}  disabled={!selectedCropItem}>Fabric</Button>
          <Row>
            
              {selectedCropItem && activeItem === "Color" &&
              <Row className="p-2" onClick={()=>getColorUpdate(color)}>
                <Col>
                <SliderPicker color={color} onChange={handleChange} 
                />
                </Col>
            </Row>}
           
            {selectedCropItem && activeItem === "Fabric" &&
              <FabricComponent />
              }
          </Row>
        </Col>
        </>
    )
}
export default ColorCropTopComponent